/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../../store'

/**
 * Import
 * - Actions
 */
import {
    fecthLapseRenewal,
    fecthRenewAsIs,
    fecthRenewPolicy,
    renewalReferralReasons,
    getFullQuoteRenewal,
    checkSoftReferral,
    getRenewalVariation,
} from '../../../../actions'

/**
 * Import
 * - Page component
 */
import Summary from '../../../../components/pages/Renewals/Summary/Summary'

const mapStateToProps = (state: RootState) => {
    return {
        quote: state.quote,
        renewAsIs: state.renewals.renewAsIs,
        renewPolicy: state.renewals.renewPolicy,
        lapseRenewal: state.renewals.lapseRenewal,
        softReferrals: state.step05.softReferrals,
        fullRenewal: state.quote.fullRenewals.response.renewal,
        isCollectors: get(state, 'quote.fullRenewals.response.renewal.isCollectors', false),
        isMuseums: get(state, 'quote.fullRenewals.response.renewal.isMuseums', false),
        isDealersStock: get(state, 'quote.fullRenewals.response.renewal.isDealersStock', false),
        isWineSpirits: get(state, 'quote.fullRenewals.response.renewal.isWineSpirits', false),
    }
}

export default connect(
    mapStateToProps,
    {
        fecthLapseRenewal,
        fecthRenewAsIs,
        fecthRenewPolicy,
        renewalReferralReasons,
        getFullQuoteRenewal: getFullQuoteRenewal,
        checkSoftReferral: checkSoftReferral,
        getRenewalVariation: getRenewalVariation,
    }
)(Summary)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Renewals/Summary/Summary.tsx